<template>
  <nav>
    <DesktopOnly css>
      <AppContainer class="flex justify-between items-center py-4">
        <NavBarLogo />
        <div class="links">
          <NavBarLinks row />
          <NavBarCta />
        </div>
      </AppContainer>
    </DesktopOnly>

    <MobileOnly css>
      <AppContainer class="links">
        <NavBarLogo icon />
        <div class="flex items-center">
          <NavBarMobile />
        </div>
      </AppContainer>
    </MobileOnly>
  </nav>
</template>

<style scoped>
nav {
  background: #e4ecf5;
  z-index: 10;
}
.links {
  display: flex;
  align-items: center;
  gap: var(--space-8);
  padding-block: var(--space-2);
  font-size: 15px;
  font-weight: 500;
}

@media (min-width: 850px) {
  nav {
    border-bottom: 1px solid #ebebeb;
  }
}

@media (max-width: 850px) {
  .links {
    justify-content: space-between;
    width: 100%;
  }
}
</style>